import { waitUntilGliderIsLoaded } from "../_waitUntilGliderIsLoaded";

class SectionFeedbacksOffsetSlider {
    static sliderBreakpoints = [
        {
            breakpoint: 1440,
            settings: { slidesToShow: 3.5 },
        },
        {
            breakpoint: 1024,
            settings: { slidesToShow: 2.5 },
        },
        {
            breakpoint: 840,
            settings: { slidesToShow: 1.333 },
        },
        {
            breakpoint: 640,
            settings: { slidesToShow: 2.333 },
        },
        {
            breakpoint: 120,
            settings: { slidesToShow: 1.333 },
        },
        {
            breakpoint: 0,
            settings: { slidesToShow: 1.333 },
        }
    ];

    constructor(chapterEl) {
        this.chapterEl = chapterEl;
        this.quoteEls = this.chapterEl.querySelectorAll('.blockquote');

        if (!this.quoteEls.length) {
            console.warn('TOUJOU: Could not initialize the "section--feedbacks-as-offset-slider" element because no quotes were found!');
            return;
        }

        this._init();
    }

    _init() {
        this._slider = this._createSlider();
        this.chapterEl.appendChild(this._slider);

        requestAnimationFrame(() => {
            this._initSlider();
            this._cleanupChapterMarkup();
        });
    }

    _createSlider() {
        // Create an outer wrapper (for styling/layout purposes)
        const sliderWrapper = document.createElement("div");
        sliderWrapper.classList.add("feedbacks-offset-slider-wrapper");

        // Create the main slider element (custom element)
        this._slider = document.createElement('toujou-slider');
        this._slider.classList.add("feedbacks-offset-slider", 'slider', 'slider--primary');

        // Create the frame element where the slides (cards) will live
        this._sliderFrame = document.createElement("div");
        this._sliderFrame.classList.add('slider__frame');
        this._sliderFrame.setAttribute('tabindex', "0");

        // Move teaser cards into the slider frame
        this.quoteEls.forEach((quoteEl) => {
            this._sliderFrame.appendChild(quoteEl);
        });

        this._slider.appendChild(this._sliderFrame);

        // Wrapper for navigation arrows and pagination bullets
        this._controlsWrapper = document.createElement('div');
        this._controlsWrapper.classList.add('slider__controls');

        // Bullet pagination container
        this._sliderBulletsContainer = document.createElement('div');
        this._sliderBulletsContainer.classList = 'slider__pagination';

        // Previous arrow button
        this._sliderArrowPrev = document.createElement('button');
        this._sliderArrowPrev.classList = 'slider__control slider__control--prev';
        this._sliderArrowPrev.setAttribute('aria-label', 'Zum vorherigen Slide');
        this._sliderArrowPrev.setAttribute('tabindex', '0');

        // Next arrow button
        this._sliderArrowNext = document.createElement('button');
        this._sliderArrowNext.classList = 'slider__control slider__control--next';
        this._sliderArrowNext.setAttribute('aria-label', 'Zum nächsten Slide');
        this._sliderArrowNext.setAttribute('tabindex', '0');

        // Append controls to wrapper
        this._controlsWrapper.appendChild(this._sliderArrowPrev);
        this._controlsWrapper.appendChild(this._sliderBulletsContainer);
        this._controlsWrapper.appendChild(this._sliderArrowNext);

        // Append wrapper to slider
        this._slider.appendChild(this._controlsWrapper);

        return this._slider;
    }

    _initSlider() {
        try {
            /** @type {Glider.Options} */
            const sliderOptions = {
                slidesToShow: 1.333,
                slidesToScroll: 1,
                rewind: true,
                draggable: true,
                scrollLock: true,
                responsive: SectionFeedbacksOffsetSlider.sliderBreakpoints,
                arrows: {
                    prev: this._sliderArrowPrev,
                    next: this._sliderArrowNext,
                },
                dots: this._sliderBulletsContainer,
            };

            this._slider._glider = new Glider(this._sliderFrame, sliderOptions);

            // FORCE the responsive array back into _._opt
            this._slider._glider._opt.responsive = SectionFeedbacksOffsetSlider.sliderBreakpoints;

            // Refresh to trigger settingsBreakpoint() again
            this._slider._glider.refresh(true);
        } catch (error) {
            console.log('Could not initialize the product teaser slider', error)
        }
    }

    _cleanupChapterMarkup() {
        const chapterSpans = this.chapterEl.querySelectorAll(':scope > span:empty');
        chapterSpans.forEach(spanEl => spanEl.remove());

        const blockquoteContainers = this.chapterEl.querySelectorAll(':scope > .blockquotes');
        blockquoteContainers.forEach(containerEl => containerEl.remove());
    }
}

async function initSectionFeedbacksOffsetSlider() {
    const feedbackAsOffsetSliderChapters = document.querySelectorAll('.section--feedbacks-as-offset-slider');
    if (!feedbackAsOffsetSliderChapters.length) return;

    await waitUntilGliderIsLoaded();

    feedbackAsOffsetSliderChapters.forEach(chapterEl => {
        if (!chapterEl.sectionFeedbacksOffsetSliderInstance) {
            chapterEl.sectionFeedbacksOffsetSliderInstance = new SectionFeedbacksOffsetSlider(chapterEl);
        }
    })
}

// Initialize immediately if DOM is already loaded, otherwise wait for DOMContentLoaded
if (document.readyState !== "loading") {
    initSectionFeedbacksOffsetSlider();
} else {
    document.addEventListener("DOMContentLoaded", initSectionFeedbacksOffsetSlider);
}
